"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The MediaSourceInstance model module.
 * @module model/MediaSourceInstance
 * @version 3.0
 */
var MediaSourceInstance = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>MediaSourceInstance</code>.
   * @alias module:model/MediaSourceInstance
   */
  function MediaSourceInstance() {
    _classCallCheck(this, MediaSourceInstance);
    MediaSourceInstance.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(MediaSourceInstance, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>MediaSourceInstance</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MediaSourceInstance} obj Optional instance to populate.
     * @return {module:model/MediaSourceInstance} The populated <code>MediaSourceInstance</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new MediaSourceInstance();
        if (data.hasOwnProperty('sourceId')) {
          obj['sourceId'] = _ApiClient["default"].convertToType(data['sourceId'], 'Number');
        }
        if (data.hasOwnProperty('type')) {
          obj['type'] = _ApiClient["default"].convertToType(data['type'], 'String');
        }
        if (data.hasOwnProperty('link')) {
          obj['link'] = _ApiClient["default"].convertToType(data['link'], 'String');
        }
        if (data.hasOwnProperty('codec')) {
          obj['codec'] = _ApiClient["default"].convertToType(data['codec'], 'String');
        }
        if (data.hasOwnProperty('container')) {
          obj['container'] = _ApiClient["default"].convertToType(data['container'], 'String');
        }
        if (data.hasOwnProperty('screenWidth')) {
          obj['screenWidth'] = _ApiClient["default"].convertToType(data['screenWidth'], 'Number');
        }
        if (data.hasOwnProperty('screenHeight')) {
          obj['screenHeight'] = _ApiClient["default"].convertToType(data['screenHeight'], 'Number');
        }
        if (data.hasOwnProperty('duration')) {
          obj['duration'] = _ApiClient["default"].convertToType(data['duration'], 'Number');
        }
        if (data.hasOwnProperty('bitRate')) {
          obj['bitRate'] = _ApiClient["default"].convertToType(data['bitRate'], 'Number');
        }
        if (data.hasOwnProperty('fileSize')) {
          obj['fileSize'] = _ApiClient["default"].convertToType(data['fileSize'], 'Number');
        }
        if (data.hasOwnProperty('profiles')) {
          obj['profiles'] = _ApiClient["default"].convertToType(data['profiles'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MediaSourceInstance</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MediaSourceInstance</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
        throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
      }
      // ensure the json data is a string
      if (data['link'] && !(typeof data['link'] === 'string' || data['link'] instanceof String)) {
        throw new Error("Expected the field `link` to be a primitive type in the JSON string but got " + data['link']);
      }
      // ensure the json data is a string
      if (data['codec'] && !(typeof data['codec'] === 'string' || data['codec'] instanceof String)) {
        throw new Error("Expected the field `codec` to be a primitive type in the JSON string but got " + data['codec']);
      }
      // ensure the json data is a string
      if (data['container'] && !(typeof data['container'] === 'string' || data['container'] instanceof String)) {
        throw new Error("Expected the field `container` to be a primitive type in the JSON string but got " + data['container']);
      }
      // ensure the json data is a string
      if (data['profiles'] && !(typeof data['profiles'] === 'string' || data['profiles'] instanceof String)) {
        throw new Error("Expected the field `profiles` to be a primitive type in the JSON string but got " + data['profiles']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} sourceId
 */
MediaSourceInstance.prototype['sourceId'] = undefined;

/**
 * @member {String} type
 */
MediaSourceInstance.prototype['type'] = undefined;

/**
 * @member {String} link
 */
MediaSourceInstance.prototype['link'] = undefined;

/**
 * @member {String} codec
 */
MediaSourceInstance.prototype['codec'] = undefined;

/**
 * @member {String} container
 */
MediaSourceInstance.prototype['container'] = undefined;

/**
 * @member {Number} screenWidth
 */
MediaSourceInstance.prototype['screenWidth'] = undefined;

/**
 * @member {Number} screenHeight
 */
MediaSourceInstance.prototype['screenHeight'] = undefined;

/**
 * @member {Number} duration
 */
MediaSourceInstance.prototype['duration'] = undefined;

/**
 * @member {Number} bitRate
 */
MediaSourceInstance.prototype['bitRate'] = undefined;

/**
 * @member {Number} fileSize
 */
MediaSourceInstance.prototype['fileSize'] = undefined;

/**
 * @member {String} profiles
 */
MediaSourceInstance.prototype['profiles'] = undefined;
var _default = exports["default"] = MediaSourceInstance;